<div class="lp-view-product">
  <ng-container *ngIf="!!product && !loading; else productNotFounded">
    <lp-view-header
      [title]="product.name"
      [breadcrumbs]="breadcrumbs"
      (action)="onAction($event)"
      [status]="product.status"
      [isUserOrganisation]="isUserOrganisation"
      [isExternalProduct]="isExternalProduct"
      [useUnionId]="useUnionId"
    ></lp-view-header>

    <tui-scrollbar id="viewProductScrollbar" class="lp-view-product__wrapper">
      <div class="lp-view-product__content">
        <ng-container *ngIf="isDesktop; else mobileContentTmp">
          <div class="lp-view-product__content_left-column">
            <ng-container [ngTemplateOutlet]="imagesCarousel"></ng-container>
            <ng-container [ngTemplateOutlet]="contactsBlock"></ng-container>
          </div>

          <div class="lp-view-product__content_right-column">
            <ng-container [ngTemplateOutlet]="infoBlock"></ng-container>
          </div>
        </ng-container>

        <ng-template #mobileContentTmp>
          <ng-container [ngTemplateOutlet]="imagesCarousel"></ng-container>
          <ng-container [ngTemplateOutlet]="infoBlock"></ng-container>
          <ng-container [ngTemplateOutlet]="contactsBlock"></ng-container>
        </ng-template>
      </div>

      <div [hide]="!mapVisible" class="lp-view-product__map">
        <app-map [placemarks]="placemarksForMap"></app-map>
      </div>

      <div class="lp-view-product__similar-products">
        <lp-similar-products
          [productId]="product.id"
          [unionId]="externalUnionId"
          [city]="currentCity$ | async"
        ></lp-similar-products>
      </div>
    </tui-scrollbar>

    <ng-template #imagesCarousel>
      <app-images-carousel [imageIds]="imageIds" [productUnionId]="externalUnionId"></app-images-carousel>
    </ng-template>

    <ng-template #contactsBlock>
      <lp-view-contacts-block
        [contacts]="product.contacts"
        [productUnionId]="externalUnionId"
        [useUnionId]="useUnionId"
        (externalLink)="saveRedirectLink($event)"
      >
        <button
          *ngIf="product.mapObjects && !!product.mapObjects.length"
          tuiButton
          class="button-map"
          type="button"
          appearance="lp-icon-block"
          [size]="'m'"
          [iconStart]="'@tui.map'"
          (click)="mapVisible = !mapVisible"
        >
          {{ mapVisible ? 'Скрыть карту' : 'Показать на карте' }}
        </button>
      </lp-view-contacts-block>
    </ng-template>

    <ng-template #infoBlock>
      <lp-view-info-block
        [product]="product"
        [productUnionId]="externalUnionId"
        [isUserOrganisation]="isUserOrganisation"
        [isUserAssociation]="isUserAssociation"
        (getDiscount)="onGetDiscount()"
        (externalLink)="saveRedirectLink($event)"
      ></lp-view-info-block>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="loading">
    <div class="position-by-center">
      <tui-loader size="l" [showLoader]="true" [inheritColor]="true" [overlay]="true" style="width: 100%"></tui-loader>
    </div>
  </ng-container>
</div>

<ng-template #productNotFounded>
  <ng-container *ngIf="!loading">
    <div class="lp-view-product__product-not-founded">
      <span>{{ 'components.loyaltyProgram.labels.productNotFounded' | translate }}</span>

      <app-link
        [routerLink]="'/loyalty'"
        [displayText]="'components.loyaltyProgram.buttons.homeLink' | translate"
      ></app-link>
    </div>
  </ng-container>
</ng-template>
